import type { GenerateCharacterFormValues } from '~widgets/GenerateCharacter/types';

import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

// character
export const useGenerateBotOpened = () =>
	useSendEvent(events.generator.generateBotOpened);

export const useGenerateBotPartnerStep = () =>
	useSendEvent(events.generator.generateBotPartnerStep);

export const useGenerateBotStyleStep = () =>
	useSendEvent(events.generator.generateBotStyleStep);

export const useGenerateBotGenderStep = () =>
	useSendEvent(events.generator.generateBotGenderStep);

export const useGenerateBotAppearanceStep = ({
	ethnicity,
	age,
	hair,
	figure,
}: {
	ethnicity: GenerateCharacterFormValues['ethnicity'];
	age: GenerateCharacterFormValues['age'];
	hair: GenerateCharacterFormValues['hair'];
	figure: GenerateCharacterFormValues['figure'];
}) =>
	useSendEvent(events.generator.generateBotAppearanceStep, {
		ethnicity,
		age,
		hair_color: hair,
		body_type: figure,
	});

export const useGenerateBotDescriptionStep = ({
	name,
	prompt,
}: {
	name: GenerateCharacterFormValues['name'];
	prompt: GenerateCharacterFormValues['prompt'];
}) =>
	useSendEvent(events.generator.generateBotDescriptionStep, {
		name,
		prompt,
	});

export const useGenerateBotReferenceInstruction = () =>
	useSendEvent(events.generator.generateBotReferenceInstruction);

export const useGenerateBotReferenceUploaded = () =>
	useSendEvent(events.generator.generateBotReferenceUploaded);

export const useGenerateBotPhotoCheck = () =>
	useSendEvent(events.generator.generateBotPhotoCheck);

export const useGenerateBotGenerationStep = () =>
	useSendEvent(events.generator.generateBotGenerationStep);

export const useGenerateBotRebuild = () =>
	useSendEvent(events.generator.generateBotRebuild);

export const useGenerateBotActivate = () =>
	useSendEvent(events.generator.generateBotActivate);

export const useGenerateBotActivateUsingNeurons = () =>
	useSendEvent(events.generator.generateBotActivateUsingNeurons);

export const useGenerateBotError = () =>
	useSendEvent(events.generator.generateBotError);

// media
export const useGenerateImprovePrompt = (source: 'photo' | 'video') =>
	useSendEvent(events.generator.generateImprovePrompt, {
		source,
	});

// images
export const useGenerateImagesOpened = () =>
	useSendEvent(events.generator.generateImagesOpened);

export const useGenerateImagesPromptInfo = () =>
	useSendEvent(events.generator.generateImagesPromptInfo);

export const useGenerateImagesReuseParams = () =>
	useSendEvent(events.generator.generateImagesReuseParams);

export const useGenerateImagesSubmitted = ({
	freeGenerations,
}: {
	freeGenerations: number;
}) =>
	useSendEvent(
		freeGenerations
			? events.generator.generateImagesSubmittedWithFree
			: events.generator.generateImagesSubmitted
	);

export const useGenerateImagesError = () =>
	useSendEvent(events.generator.generateImagesError);

export const useGenerateImagesDeleted = () =>
	useSendEvent(events.generator.generateImagesDeleted);

export const useGenerateImagesViewGallery = () =>
	useSendEvent(events.generator.generateImagesViewGallery);

export const useGenerateImagesDownloadImage = () =>
	useSendEvent(events.generator.generateImagesDownloadImage);

export const useGenerateImagesWithdrawNeurons = () =>
	useSendEvent(events.generator.generateImagesWithdrawNeurons);

export const useGenerateImagesBoughtSubscription = () =>
	useSendEvent(events.generator.generateImagesBoughtSubscription);

// video

export const useGenerateVideoOpened = () =>
	useSendEvent(events.generator.generateVideoOpened);

export const useGenerateVideoSubmitted = (free: boolean) =>
	useSendEvent(
		free
			? events.generator.generateVideoSubmittedWithFree
			: events.generator.generateVideoSubmitted
	);

export const useGenerateVideoSurpriseMe = () =>
	useSendEvent(events.generator.generateVideoSurpriseMe);

export const useGenerateVideoSelectModel = () =>
	useSendEvent(events.generator.generateVideoSelectModel);

export const useGenerateVideoPickModel = () =>
	useSendEvent(events.generator.generateVideoPickModel);

export const useGenerateVideoSelectGender = () =>
	useSendEvent(events.generator.generateVideoSelectGender);

export const useGenerateVideoReuseParams = () =>
	useSendEvent(events.generator.generateVideoReuseParams);

export const useGenerateVideoError = () =>
	useSendEvent(events.generator.generateVideoError);

export const useGenerateVideoDeleted = () =>
	useSendEvent(events.generator.generateVideoDelete);

export const useGenerateVideoViewGallery = () =>
	useSendEvent(events.generator.generateVideoViewGallery);

export const useGenerateVideoAboutPrompt = () =>
	useSendEvent(events.generator.generateVideoAboutPrompt);
